<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>
<style src="./bubbleToolTV.scss" lang="scss"></style>

<script>
import { mapState, mapActions } from 'vuex'
import { getSocialMediaIconForSource } from '@/helper'
import { filter } from 'lodash'
import ComponentLoader from '@/components/modules/ComponentLoader'
import OccasionsSliderModule from '@/components/modules/occasions/OccasionsSliderModule'

export default {
  name: 'BubbleToolTV',
  components: {
    ComponentLoader,
    OccasionsSliderModule,
  },
  data() {
    return {
      clampLines: 7,
      resizeTimer: null,
      vTimeline: null,
      dynamiclHeight: 0,
    }
  },
  computed: {
    ...mapState('pages', [ 'page' ]),
    ...mapState('auth', ['settings']),
    articleTeaser() {
      return this.page.modules[0] && this.page.modules[0].data && this.page.modules[0].data.results ? this.page.modules[0].data.results : false
    },
    webnews() {
      return this.page.modules[2] && this.page.modules[2].data && this.page.modules[2].data.results ? this.page.modules[2].data.results.news.slice(0, 3) : false
    },
    topArticle() {
      return this.page.modules[3] && this.page.modules[3].data && this.page.modules[3].data.results && this.page.modules[3].data.results.teasers ? this.page.modules[3].data.results.teasers[0] : false
    },
  },
  watch: {
    articleTeaser(val) {
      if (val) {
        this.$nextTick(() => {
          this.vTimeline = this.$refs.vTimeline.$el
          this.timelineItems(this.vTimeline)
        })
      }
    },
  },
  created() {
    if (this.settings && this.settings.pages && this.settings.pages.bubble_tool) {
      this.getPage(this.settings.pages.bubble_tool)
    } else {
      this.$router.replace({ name: '404' })
    }
  },
  mounted() {
    window.addEventListener('resize', this.transformTimeline)
    window.addEventListener('resize', this.getDynamiclHeight)
  },
  updated() {
    this.getDynamiclHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getDynamiclHeight)
  },
  methods: {
    ...mapActions('pages', [ 'getPage' ]),
    transformTimeline() {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        this.timelineItems(this.vTimeline)
      }, 500)
    },
    getSocialMediaIconForSource,
    getArticleImage(article) {
      if (article.images && article.images.teaser && article.images.teaser.link) {
        return article.images.teaser.link
      } else if (article.attachments && article.attachments[0] && article.attachments[0].link) {
        return article.attachments[0].link
      } else {
        return this.customerConfig.images.imagePlaceholder
      }
    },
    imageAttachments(attachments) {
      return filter(attachments, function(attachment) {
        return attachment.type.indexOf('image') > -1
      })
    },
    getDynamiclHeight() {
      this.dynamiclHeight = document.getElementsByClassName('dynamic_height') && document.getElementsByClassName('dynamic_height')[0] ? document.getElementsByClassName('dynamic_height')[0].offsetWidth + 105 : 0
    },
  },
}
</script>
